'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _sidebar = require('./sidebar.jsx');

var _sidebar2 = _interopRequireDefault(_sidebar);

var _topbar = require('./topbar.jsx');

var _topbar2 = _interopRequireDefault(_topbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Page = _react2["default"].createClass({
	displayName: 'Page',
	render: function render() {
		return _react2["default"].createElement(
			'div',
			null,
			_react2["default"].createElement(_topbar2["default"], { userName: this.props.userName, title: this.props.title, onLogout: this.props.onLogout }),
			_react2["default"].createElement(
				'div',
				{ id: 'wrapper' },
				_react2["default"].createElement('div', { id: 'ajax-loading', className: 'la-anim-10' }),
				_react2["default"].createElement(_sidebar2["default"], { list: this.props.sidebarList }),
				_react2["default"].createElement(
					'div',
					{ id: 'current-page', style: { "float": "left", "width": "85%" } },
					this.props.children
				)
			)
		);
	}
});

exports["default"] = Page;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/business/frame/page.jsx
 ** module id = 616
 ** module chunks = 0
 **/